import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const GovernmentPublicSector = () => {
  return (
    <>
      <SEO 
        title="Government & Public Sector Solutions - Abacies Logiciels"
        description="Modernize public services with secure, compliant government technology solutions including citizen portals, case management systems, and digital transformation for public sector organizations."
        keywords="government technology, public sector solutions, government software, citizen services, public sector digital transformation, government IT"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Government & Public Sector
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the Government & Public Sector page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for Government & Public Sector. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default GovernmentPublicSector;
